import config from '../../config';
import { applyPathParams } from '../util/DataHelpers';

import { BaseRequestService } from './BaseRequest.service';

const API_PATH: any = {
  results: '/Results/$1',
};

class GatewayRestService extends BaseRequestService {
  private static instance: GatewayRestService;

  protected getBaseUrl(): string {
    return `https://${config.gateway.url}`;
  }

  private constructor() {
    super();
  }

  static getInstance(): GatewayRestService {
    if (!this.instance) {
      this.instance = new GatewayRestService();
    }
    return this.instance;
  }

  public async get(accessId: string) {
    const path = applyPathParams(API_PATH.results, [ accessId ]);

    return this.api.get<any[]>(path);
  }
}

export default GatewayRestService;
